<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
  >
    <line
      x1="2.15257"
      y1="2.3125"
      x2="17.0312"
      y2="17.1912"
      stroke="#212121"
      stroke-width="3"
      stroke-linecap="round"
    />
    <line
      x1="1.57812"
      y1="17.1912"
      x2="16.4568"
      y2="2.3125"
      stroke="#212121"
      stroke-width="3"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'CloseFilter',
};
</script>
